import {Observable} from 'rxjs/Observable';
import get from 'lodash/get';
import includes from 'lodash/includes';
// import {RetailerItemImageType} from 'pages/Rewards/utils';
import * as RewardUtils from 'pages/Rewards/utils';
import {filterOptionsFactory, sortOptionsFactory} from 'viewOptions/factories';
import * as ViewOptionsActions from 'viewOptions/actions';
import * as ResourceApi from 'api/resources';
import * as ResourceActions from 'resources/actions';
import * as ImagesActions from 'pages/Images/actions';
import * as RewardsStoreApi from 'api/rewards-store';
import * as RewardsActions from './actions';
import {getStoreEscrow} from './selectors';
import {isNoU} from "../../utils/DBUtils";

const handleError = error => Observable.of({type: 'ERROR', error});

const getTopRewardsEpic = action$ => action$.ofType(
  RewardsActions.Types.REQUEST_TOP_REWARDS,
  RewardsActions.Types.SET_CURRENT_LANG
)
  .mergeMap(action => (
    RewardsStoreApi.getBestSellingItems(action.lang)
      .map(({response}) => RewardsActions.receivedTopRewardsAction(response.object))
      .catch(handleError)
  ));

const getStoreAccountEpic = (action$, store) => action$.ofType('RECEIVED_ALL_RESOURCES_SITE')
  .switchMap(() => (
    action$.ofType(RewardsActions.Types.SET_CURRENT_LANG)
      .mergeMap(action => {
        const state = store.getState();
        const sites = state.sites.resources;

        const lang = action.lang || state.rewards.selectedLang;
        const siteId = Object.keys(sites).find(siteId => includes(sites[siteId].supportedLanguages, lang));

        if (get(state.rewards.currentStoreAccount, 'siteId', null) === siteId) {
          // nothing to do, it's already set.
          return Observable.empty();
        }

        const {storeAccountsById} = state.rewards;

        const storeAccountIdFound = Object.keys(storeAccountsById).find(storeAccountId => {
          const storeAccount = storeAccountsById[storeAccountId];
          return storeAccount.siteId === siteId;
        });

        if (storeAccountIdFound) {
          // the StoreAccount we want is already in the Redux store, so just set it.
          const currentStoreAccount = storeAccountsById[storeAccountIdFound];
          return Observable.of(RewardsActions.setStoreAccountAction(currentStoreAccount));
        }

        // else fetch the StoreAccount.
        const storeAccountFetch$ = RewardsStoreApi.getStoreAccount(siteId);
        const postActions = [
          RewardsActions.receivedStoreAccountAction,
          RewardsActions.setStoreAccountAction
        ];

        return storeAccountFetch$
          .mergeMap(({response}) => {
            const [storeAccount] = response.object;
            return Observable.of(...postActions.map(action => action(storeAccount)));
          })
          .catch(handleError);
      })
  ));


// we want to fetch associated Retailers and StoreEscrows whenever we receive a new StoreAccount
// resource, but not necessarily every time we set the current StoreAccount in the Redux store.
// NOTE: this is used for the store
// const getRetailersEpic = action$ => action$.ofType(RewardsActions.Types.RECEIVED_STORE_ACCOUNT, RewardsActions.Types.REQUEST_RETAILERS)
//   .mergeMap(action => {
//     console.log("deprecated: getRetailersEpic");  
//     return RewardsStoreApi.getRetailers(action.storeAccount.id)
//       .map(({response}) => RewardsActions.receivedRetailersAction(response.object, action.storeAccount))
//       .catch(handleError)

//     }
//   );

// NOTE: this is used for the receipt step AND 
const getRetailersByNgcEndpointEpic = action$ => action$.ofType(RewardsActions.Types.SET_NGC_ENDPOINT, RewardsActions.Types.RECEIVED_NGC_ENDPOINT_FOR_STORE)
  .mergeMap(action => {
    console.log(action);
    let endpointId = action.ngcEndpoint;
    // ugh. hack. the SET_NGC_ENDPOINT (dropdown) sends ids. RECEIVED_NGC_ENDPOINT_FOR_STORE sends an ngcendpoint object.
    if (endpointId.hasOwnProperty('id')) {
      endpointId = endpointId.id;
    }
    return RewardsStoreApi.getRetailersByNgcEndpoint(endpointId)
      .map(({response}) => RewardsActions.receivedRetailersAction(response.object, action.storeAccount))
      .catch(handleError)
  });

  
const getNgcEndpointListEpic = action$ => action$.ofType(RewardsActions.Types.REQUEST_NGC_ENDPOINT_LIST, RewardsActions.Types.START_WRITE_RETAILER_ITEM)
  .mergeMap(action => {
    console.log("getNgcEndpointListEpic");
    const filterOptions = filterOptionsFactory({
      // filters: [{field: 'is_default', value: 0 }] // filter to get the non-store endpoints. instead filter on the receiving end.
    });
    const query = ResourceApi.getAll(ResourceApi.Types.NgcEndpoint, sortOptionsFactory(), filterOptions);
    

    return query
    .mergeMap(({response}) => {
      const nonStoreEndpoints = response.object.filter(endpoint => endpoint.isDefault == false);
      const storeEndpoints = response.object.filter(endpoint => endpoint.isDefault == true);
      let storeEndpoint = null;

      if (storeEndpoints.length == 1) {
        storeEndpoint= storeEndpoints[0];
      }

      return Observable.of(
        RewardsActions.receivedNgcEndpointListAction(nonStoreEndpoints),
        RewardsActions.receivedNgcEndpointForStoreAction(storeEndpoint));
    })
    .catch(handleError);    


    // works - no logic
    // return query
    //   .mergeMap(({response}) => Observable.of(
    //     RewardsActions.receivedNgcEndpointListAction(response.object),
    //   ))
    //   .catch(handleError)

  });

  const getNgcEndpointForStoreEpic = action$ => action$.ofType(RewardsActions.Types.REQUEST_NGC_ENDPOINT_LIST)
  .mergeMap(action => {
    console.log("getNgcEndpointForStoreEpic");
    const filterOptions = filterOptionsFactory({
      // filters: [{field: 'is_default', value: 0 }] // filter to get the non-store endpoints. instead filter on the receiving end.
    });
    const query = ResourceApi.getAll(ResourceApi.Types.NgcEndpoint, sortOptionsFactory(), filterOptions);
    
    return query
    .map((response) => {
        const storeEndpoints = response.response.object.filter(endpoint => endpoint.isDefault == true);
        if (storeEndpoints.length == 1) {

          return Observable.of(
            RewardsActions.setNgcEndpointAction(storeEndpoints[0]),
          );
        }
    
    })
    .catch(error => Observable.of({type: "ERROR", error}));

  });  


  // after the initial StoreEscrow fetch (happens once the current StoreAccount is loaded),
// reload the current StoreEscrow from the server if item stocks are changed.
const getStoreEscrowsEpic = (action$, store) => action$.ofType(
  RewardsActions.Types.RECEIVED_STORE_ACCOUNT,
  RewardsActions.Types.UPDATED_ITEM_STOCK,
  RewardsActions.Types.QUANTITY_UPDATE_SUCCESS,
  RewardsActions.Types.SET_CURRENT_YEAR,
  RewardsActions.Types.SET_CURRENT_MONTH
)
  .mergeMap(action => {
    let {selectedYear, selectedMonth, currentStoreAccountId} = store.getState().rewards;

    // If SET_CURRENT_YEAR action
    if (action.year) {
        selectedYear = action.year;
    }

    // the StoreAccount id is either on the RECEIVED_STORE_ACCOUNT action or in the Redux store.
    const storeAccountId = get(action, 'storeAccount.id', currentStoreAccountId);

    let month;
    if (!isNoU(selectedMonth)) {
        month = selectedMonth + 1;
    }

    const storeEscrowsFetch$ = RewardsStoreApi.getStoreEscrows(storeAccountId, selectedYear, month);

    return storeEscrowsFetch$
      .map(({response}) => RewardsActions.receivedStoreEscrowsAction(response.object))
      .catch(handleError);
  });

const createStoreEscrowEpic = action$ => action$.ofType(RewardsActions.Types.SUBMIT_CREATE_STORE_ESCROW)
  .mergeMap(action => {
    const {lang, year, month, budget, copy} = action;
    const storeEscrowCreation$ = RewardsStoreApi.createStoreEscrow(lang, year, month, budget, copy);

    return storeEscrowCreation$
      .mergeMap(({response}) => Observable.of(
        RewardsActions.receivedStoreEscrowAction(response.object),
        RewardsActions.createdStoreEscrowAction(),
        RewardsActions.endCreateStoreEscrowAction()
      ))
      .catch(err => (
        err.status === 400
          ? Observable.of(RewardsActions.errorCreatingStoreEscrowAction(err.response.errorCode))
          : handleError(err)
      ));
  });

const getRetailerItemImagesEpic = action$ => action$.ofType(RewardsActions.Types.REQUEST_RETAILER_ITEM_IMAGES)
  .map(action => {
    const filterOptions = filterOptionsFactory({
      filters: [{field: 'usedBy.id', value: action.retailerItemId}]
    });

    return ResourceActions.getAllResourcesAction(ResourceApi.Types.Image, sortOptionsFactory(), filterOptions);
  });

const getStoreCatalogEpic = (action$, store) => action$.ofType(
  RewardsActions.Types.REQUEST_STORE_CATALOG,
  RewardsActions.Types.UPDATED_RETAILER_ITEM,
  RewardsActions.Types.UPDATED_ITEM_STOCK,
  RewardsActions.Types.QUANTITY_UPDATE_SUCCESS,
  ResourceActions.Types.CREATED_RESOURCE,
  ResourceActions.Types.UPDATE_PAGE_NUMBER_FOR_RESOURCE,
  ViewOptionsActions.Types.TOGGLE_SORT_FOR_RESOURCE
)
  .filter(action => {
    if (action.type === ViewOptionsActions.Types.TOGGLE_SORT_FOR_RESOURCE || (
      action.type === ResourceActions.Types.UPDATE_PAGE_NUMBER_FOR_RESOURCE
    )) {
      return action.resourceType === ResourceApi.Types.StoreCatalog;
    }

    if (action.type === ResourceActions.Types.CREATED_RESOURCE || action.type === ResourceActions.Types.DELETED_RESOURCE) {
      // if a RetailerItem is created or deleted, we want a fresh StoreCatalog view that reflects that change.
      return get(action.resource, 'resourceId.type', null) === ResourceApi.Types.RetailerItem;
    }

    // otherwise it's scoped to this feature/reducer, in which case we always want to re-fetch.
    return true;
  })
  .map(action => {
    const state = store.getState();
    const {selectedLang, selectedYear, selectedMonth} = state.rewards;

    // API month numbers are one-indexed
    const monthNumber = selectedMonth + 1;
    const lang = action.lang || selectedLang;

    const escrowId = action.escrowId || get(getStoreEscrow({
      lang: selectedLang,
      year: selectedYear,
      month: monthNumber
    })(state), 'id', null);

    if (!escrowId) {
      return handleError(`No StoreEscrow found for month/year ${monthNumber}/${selectedYear} for language ${lang}`);
    }

    const count = 20;

    // pass null sortOptions to offload sorting responsibilities to the 'resources' epic.
    const page = action.page || null;
    const sortOptions = null;

    return ResourceActions.getResourcePageAction(
      ResourceApi.Types.StoreCatalog,
      count,
      page,
      sortOptions,
      filterOptionsFactory({
        filters: [
          {field: 'lang', value: lang},
          {field: 'escrowId', value: escrowId}
        ]
      })
    );
  });

const getStoreOrdersEpic = action$ => action$.ofType(RewardsActions.Types.REQUEST_STORE_ORDERS)
  .mergeMap(action => (
    RewardsStoreApi.getStoreOrders(action.retailerItemId, action.year, action.month, action.numPerPage, action.currentPage)
      .map(({response}) => RewardsActions.receivedStoreOrdersAction(response))
      .catch(handleError)
  ));

const resendOrderEmailEpic = action$ => action$.ofType(RewardsActions.Types.SUBMIT_RESEND_ORDER_EMAIL)
  .mergeMap(action => (
    RewardsStoreApi.resendOrderEmail(action.orderId)
      .map(({response}) => RewardsActions.resentOrderEmailAction())
      .catch(handleError)
  ));

const resentOrderEmailEpic = action$ => action$.ofType(RewardsActions.Types.RESENT_ORDER_EMAIL)
  .delay(3250) // prior CSS animation lasts 3 seconds, so clear that notification shortly afterward.
  .mapTo(RewardsActions.clearResendNotificationAction());

const increaseItemStockEpic = action$ => action$.ofType(RewardsActions.Types.SUBMIT_INCREASE_ITEM_STOCK)
  .mergeMap(action => {
    const {lang, escrowId, retailerItemId, totalItems} = action;
    const itemStockIncrease$ = RewardsStoreApi.increaseStock(lang, escrowId, retailerItemId, totalItems);

    return itemStockIncrease$
      .mergeMap(({response}) => Observable.of(
        RewardsActions.updatedItemStockAction(),
        RewardsActions.endUpdateItemStockAction()
      ))
      .catch(handleError);
  });

const decreaseItemStockEpic = action$ => action$.ofType(RewardsActions.Types.SUBMIT_DECREASE_ITEM_STOCK)
  .mergeMap(action => {
    const {lang, escrowId, retailerItemId, totalItems} = action;
    const itemStockDecrease$ = RewardsStoreApi.decreaseStock(lang, escrowId, retailerItemId, totalItems);

    return itemStockDecrease$
      .mergeMap(({response}) => Observable.of(
        RewardsActions.updatedItemStockAction(),
        RewardsActions.endUpdateItemStockAction()
      ))
      .catch(handleError);
  });

const updateQuantityEpic = action$ => action$.ofType(RewardsActions.Types.SUBMIT_UPDATE_QUANTITY)
  .mergeMap(action => {
    const {lang, escrowId, retailerItemId, totalItems} = action;
    const quantityUpdate$ = RewardsStoreApi.updateQuantity(lang, escrowId, retailerItemId, totalItems);

    return quantityUpdate$
      .map(({response}) => RewardsActions.updateQuantitySuccessAction(retailerItemId))
      .catch(err => (
        err.status === 400
          ? Observable.of(RewardsActions.updateQuantityErrorAction(retailerItemId, err.response.errorCode))
          : handleError(err)
      ));
  });

const exportStoreDataEpic = action$ => action$.ofType(RewardsActions.Types.EXPORT_STORE_DATA)
  .mergeMap(action => (
    RewardsStoreApi.exportStoreData(action.lang, action.escrowId)
      .map(() => RewardsActions.exportedStoreDataAction(true))
      .catch(err => Observable.of(RewardsActions.exportStoreDataAction(false)))
  ));

const createdRetailerItemImageEpic = action$ => action$.ofType(ImagesActions.Types.CREATED_IMAGE)
  .filter(action => {
    console.log(action);
    console.log(action.image.imageType);
    return action.image.imageType === RewardUtils.RetailerItemImageType
  })
  .map(action => RewardsActions.updateRetailerItemInProgressAction({imageId: action.image.resourceId.id}));

const createRetailerItemEpic = action$ => action$.ofType(RewardsActions.Types.SUBMIT_CREATE_RETAILER_ITEM)
  .mergeMap(action => (
    RewardsStoreApi.createRetailerItem(action.lang, action.formData)
      .mergeMap(({response: {object}}) => Observable.of(
        ResourceActions.createdResourceAction(object, object, [], [], []),
        RewardsActions.endWriteRetailerItemAction()
      ))
      .catch(err => (
        err.status === 400
          ? Observable.of(RewardsActions.errorCreatingRetailerItemAction(err.response.errorCode))
          : handleError(err)
      ))
  ));

const updateRetailerItemEpic = action$ => action$.ofType(RewardsActions.Types.SUBMIT_UPDATE_RETAILER_ITEM)
  .mergeMap(action => {
    // elide StoreCatalog-specific, as well as meta-ish, properties like ids, lang, etc. from the resource object.
    const {allocated, inStock, purchased, id, resourceId, lang, canDelete, ...changes} = action.retailerItem;

    // we have to let the API know that, even though this resource comes from the StoreCatalog
    // virtual resource, deep down it is truly a RetailerItem.
    const retailerItemResourceId = {
      type: ResourceApi.Types.RetailerItem,
      id
    };

    const retailerItemUpdate$ = RewardsStoreApi.updateRetailerItem(action.lang, id, changes, retailerItemResourceId);

    return retailerItemUpdate$
      .mergeMap(({response}) => Observable.of(
        RewardsActions.updatedRetailerItemAction(),
        RewardsActions.endWriteRetailerItemAction()
      ))
      .catch(handleError);
  });

const deleteRetailerItemEpic = action$ => action$.ofType(RewardsActions.Types.DELETE_RETAILER_ITEM)
  .mergeMap(action => {
    const {lang, retailerItem} = action;
    const retailerItemDeletion$ = RewardsStoreApi.deleteRetailerItem(lang, retailerItem.id);

    return retailerItemDeletion$
      .mergeMap(() => Observable.of(
        ResourceActions.deletedResourceAction(retailerItem, retailerItem, [], [], []),
        RewardsActions.endWriteRetailerItemAction()
      ))
      .catch(handleError);
  });

export default [
  getTopRewardsEpic,
  getStoreAccountEpic,
  // getRetailersEpic,
  getRetailersByNgcEndpointEpic,
  getNgcEndpointListEpic,
  getStoreEscrowsEpic,
  createStoreEscrowEpic,
  getRetailerItemImagesEpic,
  getStoreCatalogEpic,
  getStoreOrdersEpic,
  resendOrderEmailEpic,
  resentOrderEmailEpic,
  increaseItemStockEpic,
  decreaseItemStockEpic,
  updateQuantityEpic,
  exportStoreDataEpic,
  createdRetailerItemImageEpic,
  createRetailerItemEpic,
  updateRetailerItemEpic,
  deleteRetailerItemEpic
];



// WEBPACK FOOTER //
// ./public/pages/Rewards/epics.js